module.exports = __webpack_public_path__ + "static/media/fruit-peach-2.c877e5c1.png";